import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import api from '../utils/api';
import moment from 'moment';
import './styles/StudentProfilePage.css';
import { useNavigate } from 'react-router-dom';

const PublicStudentProfilePage = ({isSidebarCollapsed}) => {
    const { studentId } = useParams(); // Get the student ID from URL parameters
    const [student, setStudent] = useState(null);
    const [levelHistories, setLevelHistories] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchStudentDetails = async () => {
            try {
                const response = await api.get(`/student/public/detail/${studentId}`);
                setStudent(response.data.data.student || null);
            } catch (error) {
                console.error("Failed to fetch student details", error);
            }
        };
        fetchStudentDetails();
    }, [studentId]);

    if (!student) return <p>Loading public student details...</p>;

    return (
        <div className={`page-content ${isSidebarCollapsed ? 'collapsed' : ''}`}>
            <div className="page-title">Public Student profile</div>
            <div className="form-container">
                <div className="section">
                    <h3 className="section-header">Student Data</h3>
                    <table>
                        <tbody>
                            <tr>
                                <td>Name</td>
                                <td>:</td>
                                <td>{student.student_name}</td>
                            </tr>
                            <tr>
                                <td>Birth Date</td>
                                <td>:</td>
                                <td>{moment(student.birth_date).format('DD MMMM YYYY')}</td>
                            </tr>
                            <tr>
                                <td>Branch</td>
                                <td>:</td>
                                <td>{student.Branch.branch_name}</td>
                            </tr>
                            <tr>
                                <td>Address</td>
                                <td>:</td>
                                <td>{student.address}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="section">
                    <h3 className="section-header">Contact Person Data</h3>
                    <table>
                        <tr>
                            <td>Name</td>
                            <td>:</td>
                            <td>{student.contact_person_name}</td>
                        </tr>
                        <tr>
                            <td>Relationship</td>
                            <td>:</td>
                            <td>{student.relationship}</td>
                        </tr>
                        <tr>
                            <td>Phone Number</td>
                            <td>:</td>
                            <td>{student.phone_number}</td>
                        </tr>
                    </table>
                </div>
                <div className="button-group-profile">
                    <button className="profile-button" onClick={() => navigate(`/student/public/edit/${student.student_id}`)}>Edit</button>
                    <button className="profile-button" onClick={() => navigate('/students')}>Back</button>
                </div>
            </div>
        </div>
    );
};

export default PublicStudentProfilePage;
